export { default as TestReport } from './testReport/testReport';
export { default as AssetMasterReport } from './asset.master.report';
export { default as AssetBorrowReport } from './asset.borrow.report';
export { default as AssetReturnReport } from './asset.return.report';
export { default as AssetOwnerTransferReport } from './asset.ownertransfer.report';
export { default as AssetWriteOffReport } from './asset.writeoff.report';
export { default as AssetCountReport } from './asset.count.report';
